module.exports = __webpack_public_path__ + "media/img/scholarships/English Year 12-0367efa577ba26b7da2d50f8450d87b3.svg";